import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';

import Popover from '../popover';

const MobileDropdownOptions = ({
  options,
  hasCancelSaveActions,
  values,
  onSelect,
  onClose,
  onCancel,
  onSave,
  reactNode,
  additionalInfo,
  className,
}) => {
  const t = useTranslation();

  const renderItem = (item) => {
    const { countryAlias, flagAlias, icon, amount, name, label } = item;

    return (
      <div className="option-content-layout">
        {icon && <i className={`global-icon ${icon}`} />}
        {countryAlias && (
          <span className={`flag icon-${(flagAlias || countryAlias).toLowerCase()}`} />
        )}
        <div className="option-text-group">
          <p className="option-title">{name || label}</p>
          {amount && (
            <h3 className="option-sub-title">
              {amount}
            </h3>
          )}
        </div>
      </div>
    );
  };

  return (
    <Popover onClose={onClose} className={`P-popover-no-content-padding P-mobile-popover ${className}`}>
      {(reactNode || additionalInfo) &&
      <p className="P-additional-info">
        {reactNode}
        {additionalInfo}
      </p>}
      <div className="mobile-dropdown-container">
        <div className="mobile-dropdown-list">
          {options.map((item) => {
            const isSelected = values.includes(item.value);
            return (
              <div
                key={item.value}
                className={`mobile-dropdown-item ${isSelected ? 'is-active' : ''}`}
                onClick={(e) => onSelect(e, item)}
              >
                {renderItem(item)}
                {isSelected && (
                  <i className="global-icon icon-regular-checkmark selection-icon" />
                )}
              </div>
            );
          })}
        </div>

        {hasCancelSaveActions && (
          <div className="mobile-dropdown-footer">
            <button className="btn-cancel" onClick={onCancel}>{t('Cancel')}</button>
            <button className="btn-save" onClick={onSave}>{t('Save')}</button>
          </div>
        )}
      </div>
    </Popover>
  );
};

MobileDropdownOptions.propTypes = {
  hasCancelSaveActions: PropTypes.bool,
  options: PropTypes.array,
  values: PropTypes.array,
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  additionalInfo: PropTypes.string,
  reactNode: PropTypes.node,
};

export default MobileDropdownOptions;
